/* eslint-disable */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Cascader } from 'antd'
import { handleControl } from './control'
import { renderLabelString, renderTextUn } from '@/utils/renderUtils'
import { renderTree } from '@/utils/helpers'

const { SHOW_CHILD } = Cascader

const I2CascaderControl = (props) => {
    const {
      propsClassName, propsStyle, propsClassSpan, style,// 样式 className
      modalProps, label, ending, optionDisabled,// 组件 功能参数
      options, query, value, searchKey, // 组件 数据源
      clearKey, killPending, reduxObj, dropdownRender, expandTrigger, disabledOption, valid,// 请求相关控制数据
      action, actionChange, resAction, headerchange // 请求方法
    } = props
		// console.log('I2CascaderControl', props)
		const [ useValue, setUseValue ] = useState({
			// useItem: query[searchKey],
			userTree: []
		})

		// 监听 options 是否要重组 树
		useEffect(() => {
			const formatOption = renderTree(options)
			setUseValue({
				...useValue,
				userTree: formatOption
			})
			// console.log('useEffectuseValue :', formatOption, 'rootTree :', rootTree, 'options :', options)
		},[options])

		const onChangeSelect = (e, option) => {
			const formatId = option.length > 0 ? option[option.length - 1].id : ''
			setUseValue({
				...useValue,
				useItem: e
			})
			// ----- 提交组件 -----------
			handleControl(
				props,
				{ [searchKey]: formatId },
				option
			)
		}

		return (
			<div className={propsClassName} style={propsStyle}>
				<span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
				<Cascader
        	// -- modalProps
					style={style}
					showSearch={true}
					allowClear={true}
					placeholder={`请选择${renderTextUn(label)}`}
					expandTrigger={expandTrigger}
					{...modalProps}
					// ---

					showCheckedStrategy={SHOW_CHILD}
					value={useValue.useItem}
					options={useValue.userTree}
					onChange={onChangeSelect}
				/>
			</div>
    )

}
export default I2CascaderControl

I2CascaderControl.defaultProps = {
    propsClassName: 'mode',
    propsClassSpan: '',
    style: { minWidth: 200 },
    modalProps: {},
    query: {},
    options: [],
    ending: false,
    killPending: false,
    optionDisabled: () => {},
    expandTrigger: 'hover', // 触发下级方式
    disableOptionType: 'fullIds', // 需要禁用的key
		disabledOption: [], // 需要禁用的数据
    valid: true, // 基本可选范围 （true：可选生效 | false： 无效可选（包含生效））
    dropdownRender: false
  }
  